<template>
    <BreadCrumb PageTitle="Liste des paiements annulés ou échoué" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/Paiement/ListePaiementAnnules.vue";
    export default defineComponent({
      name: "ListePaiementAnnulesPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>